<template>
  <v-app :class="uamsShow ? 'uamsShow' : ''" :style="uamsShow ? 'margin: 12px;' : ''">
    <v-card class="height-100" elevation="0" v-show="validing">
      <v-card-title>
        <v-icon color="blue" class="mr-1">mdi-police-badge-outline</v-icon> 单位服务资质审核
        <v-spacer />
        <v-chip :color="!stateIndex ? 'blue' : ''" :outlined="!stateIndex" class="ml-3 elevation-0" @click="search()" label> <span class="mr-1 blue--text" style="font-size: 4px">●</span> 全部 </v-chip>
        <v-chip :color="stateIndex && stateIndex == '0' ? 'orange' : ''" :outlined="stateIndex == '0'" class="ml-3 elevation-0" @click="search('0')" label> <span class="mr-1 orange--text" style="font-size: 4px">●</span> 待审核 </v-chip>
        <v-chip :color="stateIndex && stateIndex == '1' ? 'green' : ''" :outlined="stateIndex == '1'" class="ml-3 elevation-0" @click="search('1')" label> <span class="mr-1 green--text" style="font-size: 4px">●</span> 已通过 </v-chip>
        <v-chip :color="stateIndex && stateIndex == '2' ? 'red' : ''" :outlined="stateIndex == '2'" class="ml-3 elevation-0" @click="search('2')" label> <span class="mr-1 red--text" style="font-size: 4px">●</span> 不通过 </v-chip>
        <v-text-field
          v-model="queryParam.condition"
          class="ml-3"
          style="max-width: 420px"
          placeholder="请输入单位名称/统一信用证号"
          append-icon="mdi-magnify"
          @click:append="searchQuery()"
          @keyup.enter="searchQuery()"
          hide-details
          dense
          outlined
          clearable
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-divider />
        <v-data-table :headers="headers" :items="desserts" :loading="loading" disable-pagination loading-text="数据加载中..." class="elevation-0" hide-default-footer>
          <template v-slot:[`item.first_col`]="{ item }">
            <span>{{ desserts.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:[`item.postName`]="{ item }">
            <span class="blue--text pointer" @click="toView(item)">{{ item.postName | txt(15) }}</span>
          </template>
          <template v-slot:[`item.entName`]="{ item }">
            <span>{{ item.entName | txt(15) }}</span>
          </template>
          <template v-slot:[`item.state`]="{ item }">
            <v-chip small dark :color="item.state | dict('0:amber/1:green/2:red')">{{ item.state | dict("0:待审核/1:已通过/2:不通过") }}</v-chip>
          </template>
          <template v-slot:[`item.linkTele`]="{ item }">
            <span>{{ item.linkTele ? item.linkTele : "无" }}</span>
          </template>
          <template v-slot:[`item.operateTime`]="{ item }">
            <span>{{ item.operateTime | date("yyyy-MM-dd") }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <span class="mr-4 pointer" :class="item.state == 0 ? 'green--text' : 'blue--text'" @click="toView(item.id)">{{ item.state == 0 ? "审核" : "详情" }}</span>
          </template>
        </v-data-table>
        <v-divider />
        <pagination :page-sizes="[10, 10]" :page-data="pageData" @pageChange="getListPage" />
      </v-card-text>
    </v-card>
    <wtk-message><!--弹出消息区域--></wtk-message>
  </v-app>
</template>
<script>
// import Storage from "@/commons/storage";
import Message from "@/components/message";
import pagination from "@/components/pagination";
import Mixins from "@/compositions/mixins/minxs";
export default {
  mixins: [Mixins],
  components: { pagination },
  name: "DeptRolesPage",
  data: () => ({
    validing: false,
    loading: false,
    headers: [
      { text: "序号", value: "first_col", sortable: false, width: 60 },
      { text: "信用证号", value: "uniCode", sortable: false, width: 140 },
      { text: "单位名称", value: "uniName", sortable: false },
      // { text: "单位地址", value: "address", sortable: false },
      { text: "联系人", value: "contact", sortable: false, width: 90 },
      { text: "联系电话", value: "linkTele", sortable: false, width: 138 },
      { text: "申请类别", value: "projName", sortable: false},
      { text: "申报时间", value: "operateTime", sortable: false, width: 120 },
      { text: "审核状态", value: "state", sortable: false, width: 90 },
      { text: "操作", value: "actions", sortable: false, width: 80 },
    ],
    desserts: [],
    url: { list: "udsx/dept-ureg/page" },
    stateIndex: "",
    uamsShow: false,
  }),
  watch: {
    $route(to, from) {
      this.uamsShow = location.href.includes("/uams-");
      if (to.query.bid != from.query.bid) {
        if (to.query.bid != undefined) {
          this.queryParam.bid = to.query.bid;
          this.loadPage();
        }
      }
      if (to.query.bizType != from.query.bizType) {
        if (to.query.bizType != undefined) {
          this.queryParam.bizType = to.query.bizType;
          this.loadPage();
        }
      }
      if (to.query.projCode != from.query.projCode) {
        if (to.query.projCode != undefined) {
          this.queryParam.projCode = to.query.projCode;
          this.loadPage();
        }
      }
    },
  },
  activated() {
    this.uamsShow = location.href.includes("/uams-");
    Message.loading.show();
    this.$vuetify.theme.dark = false;
    this.queryParam.bid = this.$route.query.bid;
    this.queryParam.bizType = this.$route.query.bizType;
    this.queryParam.projCode = this.$route.query.projCode;
    this.loadPage();
    this.validing = true;
    Message.loading.hide();
  },
  methods: {
    //搜索
    search(index) {
      this.stateIndex = index;
      this.queryParam.state = index;
      this.searchQuery();
    },
    //详情及审核
    toView(id) {
      if (this.uamsShow) {
        this.$router.push({ path: "/uams-dept-roles-view", query: { drid: id, bid: this.queryParam.bid } });
      } else {
        this.$router.push({ path: "/dept-roles-view", query: { drid: id, bid: this.queryParam.bid } });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.border_blue {
  border: rgba(0, 110, 255, 0.979) 1px solid;
}
.uamsShow ::v-deep .v-application--wrap {
  min-height: calc(100vh - 100px);
}
::v-deep .v-data-table-header tr .text-start:nth-child(3) {
  min-width: 200px !important;
}
::v-deep .v-data-table-header tr .text-start:nth-child(4),
::v-deep .v-data-table-header tr .text-start:nth-child(7) {
  min-width: 160px !important;
}
</style>